import React, { useState } from 'react';
import BsModal from '../Common/BsModal';
import DatePicker, { Calendar } from 'react-multi-date-picker';
import DatePanel from "react-multi-date-picker/plugins/date_panel";

const DateRangeSelector = ({ show, onClose, onConfirm, buttonLabel = "Confirm" }) => {
  const [selectedDates, setSelectedDates] = useState([]);

  const handleConfirm = () => {
    const sortedDates = selectedDates.map(d => d.format("YYYY-MM-DD")) 

    onConfirm(sortedDates);
    onClose();
  };


  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Advanced Date Selection"
      size='modal-lg'
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={selectedDates.length === 0}
          >
            <i className="fa fa-check-circle mr-1"></i> {buttonLabel}
          </button>
        </>
      }
    >
     <div className="mb-4">
  <h6 className="font-weight-bold mb-3">
    <i className="fa fa-calendar-alt text-primary mr-2"></i>
    Select Dates
  </h6>
  <Calendar
    multiple
    value={selectedDates}
    onChange={setSelectedDates}
    format="YYYY-MM-DD"
    numberOfMonths={2}
    sort
    plugins={[<DatePanel />]}
    style={{
        boxShadow: 'none',
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
    }}
    />
</div>

    </BsModal>
  );
};

export default DateRangeSelector;
